import {
  useLazyGetEnterpriseDashboardOrderSensorsQuery,
  useLazyGetEnterpriseDashboardSensorStatusesQuery,
  useLazyGetEnterpriseSensorsQuery,
} from "store/api/enterpriseApi"

import { convertEnterpriseSensorsTabToTableRows } from "utils/convertData"
import { WidgetsRow } from "layouts/WidgetsLayout/WidgetsRow"
import { SensorsPageContent } from "components/sensorsTable/SensorsPageContent"
import { useSensorsPage } from "components/sensorsTable/useSensorsPage"
import { WidgetOrderedSensors } from "components/widgets/WidgetOrderedSensors"
import { WidgetSensorStatuses } from "components/widgets/WidgetSensorStatuses"

const EnterpriseSensorsPage = () => {
  const props = useSensorsPage({
    useLazyQuery: useLazyGetEnterpriseSensorsQuery,
    convertData: convertEnterpriseSensorsTabToTableRows,
    listName: "admin_sensors_list",
    tableName: "enterprise-sensors",
    isVendor: true,
  })

  return (
    <>
      <WidgetsRow>
        <WidgetOrderedSensors
          useLazyQuery={useLazyGetEnterpriseDashboardOrderSensorsQuery}
          title="Sensors by Type"
          mainLabel="Sensors"
        />
        <WidgetSensorStatuses useLazyQuery={useLazyGetEnterpriseDashboardSensorStatusesQuery} />
      </WidgetsRow>
      <SensorsPageContent {...props} />
    </>
  )
}

export default EnterpriseSensorsPage
